import {
  Typography,
  TypographyMods,
  TypographySizes,
  YouTubeVideo,
} from '@vk-cloud-solutions/marketing-ui';

import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockYoutubeVideo.module.scss';
import { ContentBlockYoutubeVideoProps } from './ContentBlockYoutubeVideo.types';

export function ContentBlockYoutubeVideo({
  video,
  description,
  ...sectionProps
}: ContentBlockYoutubeVideoProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      <figure>
        <YouTubeVideo {...video} />
        {description && (
          <figcaption className={styles.description}>
            <Typography
              tagName={TypographySizes.span}
              mods={[TypographyMods.bodyM]}
            >
              {description}
            </Typography>
          </figcaption>
        )}
      </figure>
    </ContentBlockWrapper>
  );
}
